import { RouterOutlet } from '@angular/router';
import { ChangeDetectorRef, Component, OnInit, AfterViewInit, inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SessionInitializer } from './services/session-initializer';
import { LogOut } from './store/actions/auth.actions';
import { OcultarExcepcion } from './store/actions/utils.action';
import { AppState, selectAuthState, selectPermisosState, selectUtilsState } from './store/app.states';
import { ExcepcionesComponent } from './utilerias/excepciones/excepciones.component';
import { NgIf } from '@angular/common';
import { UserService } from './core/user/user.service';
import { SharedModule } from './shared/shared.module';
// import { AuthService } from './services/auth.service';
import { environment } from '../environments/environment';
import { AuthService} from 'app/services/auth.service';
const MINUTES_UNITL_AUTO_LOGOUT = environment.expireSession; // in mins
const CHECK_INTERVAL = 1000; // in ms
const STORE_KEY = 'lastAction';
@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone : true,
    imports    : [RouterOutlet,NgIf,SharedModule],
})
@Injectable()
export class AppComponent
implements OnInit, AfterViewInit
{
    getState: Observable<any>;
    getStatePermisos: Observable<any>;
    objAutenticacion: any = null;
    objSeguridad: any = null;
    private getStateAutenticacion: Observable<any>;
    globalInterval: any;
    spinner: boolean=false;
    /**
     * Constructor
     */
    constructor(
        private store: Store,
        public sessionInitializer: SessionInitializer,
        private router: Router,
        public dialog: MatDialog,
        private cdref: ChangeDetectorRef,
        private _userService: UserService,
        private _authService: AuthService
    )
    {
        this.getStatePermisos = this.store.select(selectPermisosState);
        this.getStateAutenticacion = this.store.select(selectAuthState);
    }

    ngAfterViewInit(): void {
        this.store.select(selectUtilsState).subscribe((state: any) => {

            this.spinner = state.mostrarSpinner;
            this.cdref.detectChanges();
        });
    }
    ngOnInit(): void {
        this.validateLogin();

        this.getStateAutenticacion.subscribe((stateAutenticacion) => {
            if (stateAutenticacion.autenticado) {
                this.initEventListener();
                this.initInterval();
            } else if (this.globalInterval !== undefined) {
                clearInterval(this.globalInterval);
            }
        });

        // this.mostrarExcepcion();
    }

    //valida que sea reset de password
    private validateLogin() {
        const queryP = window.location.search.substring(1);
        const arrayData = window.location.href.split('/');
        if (this.sessionInitializer.state) {
            this.getDataRedux();
        } else if (arrayData[3] === 'upd-password') {
            this.router.navigate([`upd-password/${arrayData[4]}`]);
        } else if (arrayData[3] === 'reset-password') {
            // let rp = queryP.replace('=',':');
            // rp = rp.replace('&',',');
            // rp = `{${rp}}`
            // let Qp = JSON.parse(rp)
            // this.router.navigate([`reset-password`],{ queryParams: { ...Qp } });
            // this.router.navigate([`upd-password/${arrayData[4]}`]);
        } else {
            console.log("else sigin ")
            if (window.location.href.includes('confirmed')) {
                this.router.navigate(['sign-in'], {queryParams: {confirmed: true}});
            } else {
                this.router.navigate(['sign-in']);
            }



        }
    }

    private getDataRedux() {
        try {
            this.getStateAutenticacion.subscribe((state) => {
                this.objAutenticacion = state.seguridad;

            });

            this.getStatePermisos.subscribe((state) => {
                this.objSeguridad = state.modulos;
            });
        } catch (error) {
            console.log("errp0p catch",error)
        }
    }

    initInterval() {
        this.globalInterval = setInterval(() => {
            this.check();
        }, CHECK_INTERVAL);
    }

    check() {
        const now = Date.now();
        const timeleft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
        const diff = timeleft - now
        const isTimeout = diff < 0;

        if (isTimeout && localStorage.getItem('accessToken')) {//this._authService.isAuthenticated()) {
            this._authService.signOut()
        }
    }

    initEventListener() {
        document.body.addEventListener('click', () => this.reset());
        document.body.addEventListener('mouseover', () => this.reset());
        document.body.addEventListener('mouseout', () => this.reset());
        document.body.addEventListener('keydown', () => this.reset());
        document.body.addEventListener('keyup', () => this.reset());
        document.body.addEventListener('keypress', () => this.reset());
    }

    reset() {
        this.setLastAction(Date.now());
    }

    public setLastAction(lastAction: number) {
        localStorage.setItem(STORE_KEY, lastAction.toString());
    }

    public getLastAction() {
        // tslint:disable-next-line: radix
        return parseInt(localStorage.getItem(STORE_KEY));
    }

    mostrarExcepcion = () => {
        // this.store.select(selectUtilsState).subscribe((state: any) => {
        //     if (state.mostrarExcepcion) {
                const dialogRef = this.dialog.open(ExcepcionesComponent, {
                    width: '60%',
                    data: {
                      idTipoExcepcion: 1,//state.tipoExcepcion,
                      idUsuario: 1,
                      idOperacion: 1,
                      idAplicacion: 1,
                      moduloExcepcion: 'sel-caja-historial.component',
                      mensajeExcepcion: '',
                      stack: 1//state.pila
                    }
                  });
                //   dialogRef.afterClosed().subscribe((result: any) => {
                //       this.store.dispatch(OcultarExcepcion());
                //   });
        //     }
        // });
    }


}
